import React from 'react';
// import Confetti from 'react-confetti';
import WizardCard from '../../components/WizardCard/WizardCard';
import Appear from '../../components/Appear/Appear';
import withContainer from '../../containers/WithContainer';
import FormField from '../../components/FormField/FormField';
import { ContainerNew } from '../../containers/AppContainer';
import { StepNames } from '../../types/stepNames';

interface HowDidYouFindProps {
  appContainer: ContainerNew;
}
class HowDidYouFind extends React.Component<HowDidYouFindProps, any> {
  render() {
    return (
      <>
        {/* <Confetti
          width={window.innerWidth}
          height={window.innerHeight - 50}
          recycle={false}
          gravity={0.16}
        /> */}
        <WizardCard
          title="How did you hear about us?"
          subTitle="Before we complete, please tell us how did you hear about us."
          isDisabled={!this.props.appContainer.state.hearUs}
          delay={4}
          isLoading={this.props.appContainer.state.loading}
          onNext={() => {
            this.props.appContainer.updateProvider({
              found_reason: this.props.appContainer.state.hearUs,
              mobile: this.props.appContainer.getUserMobile(),
              onboarding_step: this.props.appContainer.stepsMapping.indexOf(
                StepNames.hearUs
              ),
            });
          }}
        >
          <Appear className="has-text-centered">
            <FormField label="" htmlFor="question" className="has-text-left">
              <input
                name="question"
                id="question"
                className="input"
                value={this.props.appContainer.state.hearUs}
                onChange={this.props.appContainer.onHearUsChange}
              />
            </FormField>
          </Appear>
        </WizardCard>
      </>
    );
  }
}

export default withContainer(HowDidYouFind);
